import React from "react";
import styled from "styled-components";
import { AiFillLinkedin, AiOutlineMail } from "react-icons/ai";
import { GoMarkGithub } from "react-icons/go";
import { Link } from "react-scroll";

function Footer() {
  return (
    <Container>
      <footer>
        <ul className="icons">
          <li>
            <a
              href="https://www.linkedin.com/in/william-cordeiro-568229238/"
              target="blank"
              name="linkedin"
            >
              <AiFillLinkedin />
            </a>
          </li>
          <li>
            <a
              href="mailto:willcordeiro800@gmail.com?subject=Hello%20again"
              target="blank"
              name="mail"
            >
              <AiOutlineMail />
            </a>
          </li>
          <li>
            <a
              href="https://github.com/willcordeiro"
              target="blank"
              name="github"
            >
              <GoMarkGithub />
            </a>
          </li>
        </ul>
        <ul className="menu">
          <Link
            smooth={true}
            to="home"
            className="notranslate home-Link"
            name="home-footer"
          >
            Home
          </Link>
          <Link
            smooth={true}
            to="about"
            className="about-Link"
            name="about-footer"
          >
            <li>About</li>
          </Link>
          <Link
            smooth={true}
            to="skills"
            className="skills-Link"
            name="skill-footer"
          >
            <li>Skills</li>
          </Link>
          <Link
            smooth={true}
            to="experience"
            className="experience-Link"
            name="experience-footer"
          >
            <li>Experience</li>
          </Link>
          <Link
            smooth={true}
            to="projects"
            className="projects-Link"
            name="projects-footer"
          >
            <li>Projects</li>
          </Link>
          <Link
            smooth={true}
            to="contact"
            className="contact-Link"
            name="contact-footer"
          >
            <li>Contact me</li>
          </Link>
        </ul>
        <div className="footer-copyright">
          <p>William Cordeiro @ 2022 All Rights Reserved.</p>
        </div>
      </footer>
    </Container>
  );
}

export default Footer;

const Container = styled.div`
  a {
    text-decoration: none;
  }

  footer {
    background-color: #272727;
    text-align: center;
    text-transform: uppercase;
    padding-top: 30px;
    margin-top: auto;
  }

  footer li {
    list-style: none;
    margin: 10px;
    display: inline-block;
  }

  .icons a {
    background: var(--color-light);
    color: #272727;
    padding: 14px;
    font-size: 20px;
    border-radius: 100%;
    display: flex;
  }
  .icons a:hover {
    background: var(--color-primary);
    transition: 0.5s;
    color: white;
  }

  .menu a {
    color: #ffffff;
    text-transform: capitalize;
    cursor: pointer;
  }
  .menu a:hover {
    color: var(--color-primary);
    transition: 0.5s;
  }

  .footer-copyright {
    background-color: #292841;
    color: #ffffff;
    padding: 15px;
    margin-top: 30px;
    text-transform: capitalize;
  }

  .footer-copyright p {
    margin-bottom: 0px;
  }
`;
